<div class="row mt-3" *ngIf="(isCheckIn || isCheckOut) && dato">
  <div class="col-12 pt-2 pr-0 container-items">
    <div class="d-flex container-item-card justify-content-between" style="border: 2px solid #c2c2c3; border-radius: 8px; gap: 25px">
      <div class="flex-xl-grow-0 flex-grow-1 w-100 pl-1 my-auto" style="width: 100%; max-width: 175px">
        <img
          style="
            width: 100%;
            height: auto;
            cursor: pointer;
            object-fit: contain;
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
          "
          width="100"
          height="100"
          [src]="dato.images[0].thumbnail"
        />
      </div>

      <div class="hotel-item-description px-0" style="width: calc(100% - 190px)">
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-between align-items-start">
            <div class="d-flex flex-column pt-2">
              <p
                class="tittle mb-1"
                style="font-family: &quot;Poppins&quot;; font-size: 20px; font-weight: 400; line-height: 1; margin-top: 5px !important"
              >
                {{ stingUpperCase(dato?.title) }}
              </p>
              <p
                class="mb-0"
                style="font-family: &quot;Poppins&quot;; font-size: 14px !important; font-weight: 400; font-style: italic; line-height: 1"
              >
                {{ stingUpperCase(dato?.gearbox) }}
              </p>
            </div>
            <div class="d-flex">
              <div class="pt-2 pr-2">
                <span *ngIf="dato.status_id === 1" class="status status-sidebar product-status-saved">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 2" class="status status-sidebar product-status-reserved">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 3" class="status status-sidebar product-status-locked">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 4" class="status status-sidebar product-status-denied">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 5" class="status status-sidebar product-status-cancelled">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 6" class="status status-sidebar product-status-paid-agency">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 7" class="status status-sidebar product-status-paid-provider">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 8" class="status status-sidebar product-status-completed">{{ dato.status }}</span>
              </div>
              <div
                *ngIf="dato.status_id !== 5"
                class="d-flex pr-3 pl-3 pb-2 pt-2"
                style="border-bottom: 2px solid #ccc; border-left: 1px solid #ccc; border-bottom-left-radius: 6px; gap: 5px"
              >
                <div *ngIf="permissions['booking.itinerarios.editarproducto'] && dato.status_id === 1" style="width: 25px; height: 25px">
                  <img
                    style="margin-top: -5px; cursor: pointer"
                    tooltip="Editar producto"
                    placement="bottom"
                    (click)="edit(dato)"
                    src="../../../../assets/icons/summary/edit.svg"
                    alt=""
                  />
                </div>
                <div style="width: 25px; height: 25px" *ngIf="dato.status_id === 1">
                  <img
                    style="margin-top: -4px; cursor: pointer"
                    tooltip="Eliminar producto"
                    (click)="removeItem(dato)"
                    placement="bottom"
                    src="../../../../assets/icons/summary/delete.svg"
                    alt=""
                  />
                </div>
                <div style="width: 25px; height: 25px" *ngIf="dato.status_id === 2">
                  <img
                    style="
                      margin-top: -4px;
                      cursor: pointer;
                      filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                    "
                    tooltip="Cancelar producto"
                    (click)="removeItem(dato)"
                    placement="bottom"
                    src="../../../../assets/icons/itinerary-detail/04-01.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-stretch" style="margin-top: 15px; margin-bottom: 15px;">
          <!-- Check-in: 3 columnas (location, seats, price) -->
          <ng-container *ngIf="isCheckIn">
            <div class="d-flex flex-column justify-content-center pt-3" style="width: 50%; min-height: 62px">
              <div class="d-flex align-items-start" style="width: 90%">
                <div>
                  <img width="25px" height="28px" style="margin-top: -5px" src="../../../../assets/icons/itinerary/lugar.svg" alt="" />
                </div>
                <p
                  class="mb-0"
                  style="
                    font-family: &quot;Rubik&quot;, serif !important;
                    font-size: 12px;
                    font-weight: 600;
                    line-height: 1;
                    text-transform: capitalize;
                  "
                >
                  {{ dato.pickupSelected ? dato.pickupSelected.name : "" }} ({{ dato.pickupSelected ? dato.pickupSelected.address : "" }})
                </p>
              </div>
              <div class="d-flex font-inline flex-row">
                <span *ngIf="isCheckIn" class="check mb-0" style="color: #22c55e">In</span>
              </div>
            </div>

            <!-- Line Vertical -->
            <div style="width: 1px; background-color: #ccc;"></div>

            <div class="d-flex justify-content-center px-3 pt-3" style="width: 32%">
              <div class="d-flex flex-column align-items-center">
                <p
                  class="p-0 m-0 inter"
                  style="font-family: &quot;Rubik&quot;, serif !important; font-size: 13px; font-weight: 600; line-height: 1"
                >
                  {{ dato.paxQuantity ? dato.paxQuantity : "No disponible" }} Asientos |
                  {{ dato.bagsQuantity ? dato.bagsQuantity : "No disponible" }} Equipaje |
                  {{ dato.doors ? dato.doors : "No disponible" }} Puertas {{ dato.airCondition ? "Aire acondicionado" : "" }}
                </p>
              </div>
            </div>

            <!-- Line Vertical -->
            <div style="width: 1px; background-color: #ccc;"></div>

            <div class="d-flex flex-column pr-3" style="width: 29%; align-items: flex-end; min-height: 62px; margin-top: -6px;">
              <p
                class="title-destiny-start text-nowrap mb-0"
                [ngClass]="{ 'pr-3': dato.status_id !== 5 }"
                style="
                  font-family: &quot;Rubik&quot;, serif !important;
                  font-size: 14px !important;
                  font-weight: 500 !important;
                  line-height: 1.3;
                  color: #666666;
                "
              >
                {{ currencyAgency.code }}
              </p>
              <div class="d-flex align-items-center">
                <p
                  class="title-destiny-start text-nowrap"
                  style="font-family: &quot;Rubik&quot;, serif !important; font-weight: 600 !important; line-height: 1.3; font-size: 19.19px;"
                >
                  <span *ngIf="dato.status_id !== 5">
                    {{ getPrice(dato) | number: "1.2-2" }}
                  </span>
                  <span *ngIf="dato.status_id === 5">
                    {{ 0 | number: "1.2-2" }}
                  </span>
                </p>
                <ng-container *ngIf="dato.status_id !== 5">
                  <usb-tooltip-convert-amount
                    [clientsSettingAppBooking]="clientSetting"
                    [currencyProduct]="dato.currency"
                    [valueProduct]="dato.totalPriceProf"
                  >
                  </usb-tooltip-convert-amount>
                </ng-container>
              </div>
              <div *ngIf="dato.status_id !== 5" class="d-flex flex-column justify-content-end align-items-center">
                <p
                  class="mb-0"
                  style="color: #b6b6b6;font-family: &quot;Rubik&quot;, serif !important; font-size: 12px; line-height: 1.3"
                  [ngClass]="{ 'pr-3': dato.status_id !== 5 }"
                >
                  Imp. Incl.
                </p>
                <div *ngIf="dato.currency !== currencyAgency?.code" class="d-flex justify-content-end align-items-center">
                  <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">
                    <span style="color: #616161">{{ dato.currency }}</span> {{ dato.netPriceAgent | number: "1.2-2" }}
                  </p>
                  <div class="info-tool d-flex flex-column position-relative">
                    <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                    <span class="tooltip-info shadow-md">
                      <div class="d-flex justify-content-center align-items-center px-2 py-1">
                        <p class="mb-0" style="font-size: 14px; color: black">{{ userService.messageProviderAmount }}</p>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Check-out: solo columna de ubicacion y asientos (sin precio) -->
          <ng-container *ngIf="isCheckOut">
            <div class="d-flex flex-column justify-content-center pt-3" style="width: 50%; min-height: 62px">
              <div class="d-flex align-items-start" style="width: 90%">
                <div>
                  <img width="25px" height="28px" style="margin-top: -5px" src="../../../../assets/icons/itinerary/lugar.svg" alt="" />
                </div>
                <p
                  class="mb-0"
                  style="
                    font-family: &quot;Rubik&quot;, serif !important;
                    font-size: 12px;
                    font-weight: 600;
                    line-height: 1;
                    text-transform: capitalize;
                  "
                >
                  {{ dato.dropoffSelected ? dato.dropoffSelected.name : "" }} ({{ dato.dropoffSelected ? dato.dropoffSelected.address : "" }})
                </p>
              </div>
              <div class="d-flex font-inline flex-row">
                <span *ngIf="isCheckOut" class="check mb-0" style="color: #fe2e54">Out</span>
              </div>
            </div>

            <!-- Line Vertical -->
            <div style="width: 1px; background-color: #ccc;"></div>

            <div class="d-flex justify-content-center px-3 pt-3" style="width: 50%">
              <div class="d-flex flex-column align-items-center">
                <p
                  class="p-0 m-0 inter"
                  style="font-family: &quot;Rubik&quot;, serif !important; font-size: 13px; font-weight: 600; line-height: 1"
                >
                  {{ dato.paxQuantity ? dato.paxQuantity : "No disponible" }} Asientos |
                  {{ dato.bagsQuantity ? dato.bagsQuantity : "No disponible" }} Equipaje |
                  {{ dato.doors ? dato.doors : "No disponible" }} Puertas {{ dato.airCondition ? "Aire acondicionado" : "" }}
                </p>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
